import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/move';

/** 状況 `move_elsewhere`（組み立ては `../fx/move.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'move_elsewhere', role: 'effect', ...spec }, 'move_elsewhere_effect.js');
